import { asyncThunkWrapper } from "../handleAsyncThunk"
import { BASEURI, headers } from "../../utils/helper"
import { createAsyncThunk } from "@reduxjs/toolkit"

/* ---------------------------------------
Forum operations
--------------------------------------- */

// Handle retrieve forums
export const handleRetrieveAllForum = createAsyncThunk(
  "retrieveAll",
  async (data, thunkAPI) => {
    const params = {
      limit: data?.limit || null,
      search: data?.search || null,
      status: data?.status || null,
      currentPage: data?.currentPage || null,
    }

    return asyncThunkWrapper(
      {
        params,
        method: "GET",
        headers: headers(),
        url: `${BASEURI}/admin/forum/retrieve-all`,
      },
      thunkAPI,
      { showToast: false }
    )
  }
)

// Handle update forum
export const handleUpdateForum = createAsyncThunk(
  "update",
  async (data, thunkAPI) => {
    return asyncThunkWrapper(
      {
        method: "POST",
        headers: headers(),
        data: data?.formData,
        url: `${BASEURI}/admin/forum/update/${data?.id}`,
      },
      thunkAPI
    )
  }
)

// Handle delete Forum
export const handleDeleteForum = createAsyncThunk(
  "delete",
  async (id, thunkAPI) =>
    asyncThunkWrapper(
      {
        method: "DELETE",
        headers: headers(),
        url: `${BASEURI}/admin/forum/delete/${id}`,
      },
      thunkAPI
    )
)

/* ---------------------------------------
Forum categories operations
--------------------------------------- */

// Handle create forum Category
export const handleCreateForumCategory = createAsyncThunk(
  "create",
  async (data, thunkAPI) =>
    asyncThunkWrapper(
      {
        data,
        method: "POST",
        headers: {
          ...headers(),
          "Content-Type": "multipart/form-data"
        },
        url: `${BASEURI}/admin/forum/category/create`,
      },
      thunkAPI
    )
)

// Handle update forum Category
export const handleUpdateForumCategory = createAsyncThunk(
  "create",
  async (data, thunkAPI) =>
    asyncThunkWrapper(
      {
        method: "POST",
        data: data?.formData || {},
        headers: {
          ...headers(),
          "Content-Type": "multipart/form-data"
        },
        url: `${BASEURI}/admin/forum/category/update/${data?.id}`,
      },
      thunkAPI
    )
)

// Handle retrieve forum categories
export const handleRetrieveForumCategories = createAsyncThunk(
  "retrieveAll",
  async (data, thunkAPI) => {
    const params = {
      limit: data?.limit || null,
      search: data?.search || null,
      currentPage: data?.currentPage || null,
    }

    return asyncThunkWrapper(
      {
        params,
        method: "GET",
        headers: headers(),
        url: `${BASEURI}/admin/forum/category/retrieve-all`,
      },
      thunkAPI,
      {
        showToast: false,
        returnDataKey: "data"
      }
    )
  }
)

// Handle delete forum Category
export const handleDeleteForumCategory = createAsyncThunk(
  "delete",
  async (id, thunkAPI) =>
    asyncThunkWrapper(
      {
        method: "DELETE",
        headers: headers(),
        url: `${BASEURI}/admin/forum/category/delete/${id}`,
      },
      thunkAPI
    )
)